<template>
    <div>
        <div v-show="loading" class="loading-fragment"><div class="dataTables_processing panel panel-default">{{ t('Processing') }}...</div></div>
        <div v-show="!loading">
            <button @click="opened = !opened" class="btn btn-default">{{ t('Fullscreen') }}</button>

            <hr />

            <default-chart :labels="labels" :items="items" :height="75" :options="chartOptions.default"></default-chart>

            <div class="fullscreen-chart" v-bind:class="{'opened': opened}">

                <br />

                <div class="panel">
                    <div class="text-center" style="margin:auto;">
                        <datepicker v-model="date" @input="onInput" @initialized="onInput"></datepicker>
                    </div>

                    <br />

                    <div class="text-center">
                        <button @click="opened = !opened" class="btn btn-default">{{ t('Hide') }}</button>
                    </div>

                    <default-chart :labels="labels" :items="items" :height="135" :options="chartOptions.fullscreen"></default-chart>

                </div>

            </div>

        </div>

    </div>
</template>

<script>
    import DefaultChart from '../DefaultChart';
    import Datepicker from '../Datepicker.vue';

    export default
    {
        components: {DefaultChart, Datepicker},
        data()
        {
            return {
                date: null,
                opened: false,
                loading: false,
                labels: [],
                items: [],
                chartOptions: {
                    default: {
                        responsive: true,
                        legend: {
                            display: false
                        },
                        scales: {
                            yAxes: [
                                {
                                    ticks: {
                                        beginAtZero: false
                                    }
                                }
                            ]
                        }
                    },
                    fullscreen: {
                        responsive: true,
                        scales: {
                            yAxes: [
                                {
                                    ticks: {
                                        beginAtZero: false,
                                    }
                                }
                            ]
                        }
                    }
                }
            };
        },
        mounted()
        {
            if (this.$data.last_import_day) {
                this.date = this.$data.last_import_day;
            }
        },
        methods:
        {
            load() {
                this.loading = true;

                let data = {
                    date: this.date,
                };

                this.$http.post('reports/price-history-with-ceneo/'+this.$data.id, data).then(response => {
                    this.loading = false;
                    this.labels = response.body.labels;
                    this.items = response.body.items;
                }, response => {
                    this.loading = false;
                });
            },
            onInput(value) {
                this.load();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// PriceHistoryWithCeneo.vue?07b4c29c